import React, { useState } from 'react'
import axios from 'axios'
import { useTranslation } from "react-i18next";

const helptenLogo = require('./Helpten_logo_icon_white_lores.png')

const FORGOT_PASSWORD_URL = process.env.NODE_ENV === 'production'
  ? '/api/forgotPassword' : '/forgotPassword'

const CAPTCHA_URL = process.env.NODE_ENV === 'production'
  ? '/api/captcha?' : '/captcha?'

export default () => {
  const [login, setLogin] = useState('')
  const [captcha, setCaptcha] = useState('')
  const [error, setError] = useState('')
  const [attempt, setAttempt] = useState(1);
  const [success, setSuccess] = useState(false)
  const {t} = useTranslation()

  const resetPassword = async event => {
    event.preventDefault()
    setError('')
    try{
      const response = await axios.post(FORGOT_PASSWORD_URL, {login, captcha});
      for (let i = 0; i < response.data.length; ++i) {
        try{
          await axios.get(response.data[i].resetUrl);
        } catch (e) {

        }
      }
      setSuccess(true);
    } catch (e) {
      setError(t('passwordReminder.specifyRandomNumber'))
      setAttempt(attempt + 1)
    }
  }

  return (
    <div className="login-content">
      <img src={helptenLogo} height="50px"
           style={{marginTop: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto'}}
           alt="Helpten logo"
      />
      {success &&
        <div className="password-sent" style={{paddingTop: 20}}>
          {t('passwordReminder.passwordSent')}
        </div>
      }
      {!success &&
        <div>
          <div className="title-tag" style={{paddingTop: 20}}>
            {t('login.forgotPassword')}
          </div>
          {error &&
          <div role="alert" bsstyle="danger" className="alert show">
            { error }
          </div>
          }
          <form onSubmit={resetPassword}>
            <input
              className="form-control"
              id="login-input"
              type="text"
              placeholder={t('login.yourEmail')}
              onChange={e => {
                e.preventDefault()
                setLogin(e.target.value)
              }}
            />
            <img className="captcha" src={CAPTCHA_URL + attempt} alt=""/>
            <input
              className="form-control"
              id="password-input"
              type="text"
              placeholder={t("login.codeOnPicture")}
              onChange={e => {
                e.preventDefault()
                setCaptcha(e.target.value)
              }}
            />
            <button className="btn btn-lg btn-primary btn-block login-button" type="submit">{t("common.ok")}</button>
          </form>
        </div>
      }
    </div>
  )
}
